import DOMPurify, { type Config } from 'dompurify'

/**
 * Strict sanitization config for user-generated rich text content.
 * Used for ticket descriptions, comments, ChatGPT responses, rich text editor output.
 */
const RICH_TEXT_CONFIG: Config = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'u', 's',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'blockquote', 'pre', 'code',
    'ul', 'ol', 'li',
    'a', 'span', 'hr',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
  ALLOW_DATA_ATTR: false,
  ALLOW_UNKNOWN_PROTOCOLS: false,
  SAFE_FOR_TEMPLATES: true,
}

/**
 * Permissive sanitization config for email template HTML output.
 * Email templates need table layout attributes and inline styles.
 */
const EMAIL_TEMPLATE_CONFIG: Config = {
  WHOLE_DOCUMENT: true,
  ADD_TAGS: ['style', 'link'],
  ADD_ATTR: ['target', 'bgcolor', 'background', 'align', 'valign', 'cellpadding', 'cellspacing', 'border'],
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
}

/**
 * Sanitize user-generated rich text (tickets, comments, ChatGPT, editor content).
 */
export function sanitizeRichText(html: string): string {
  if (!html || html === '<p><br></p>') return ''
  return DOMPurify.sanitize(html, RICH_TEXT_CONFIG)
}

/**
 * Sanitize compiled email template HTML.
 */
export function sanitizeEmailHtml(html: string): string {
  return DOMPurify.sanitize(html, EMAIL_TEMPLATE_CONFIG)
}
